import { Link } from "react-router-dom";

export default function ConfidentialityPage() {
    return (
        <div className="h-full w-full md:p-12 p-6 bg-white dark:bg-black text-black dark:text-white flex flex-col md:gap-6 gap-4">
            <h1 className="text-4xl font-bold text-center">
                Règles de confidentialité de Tossée
            </h1>
            <br />
            <p>
                Date d'entrée en vigueur : 29 mars 2024
            </p>
            <p>
                Tossée s'engage à protéger votre vie privée. Ce Règlement de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons
                les informations relatives à nos utilisateurs concernant notre application add-on pour navigateur web (Tossée), qui est accessible depuis <Link to="/" className="underline text-secondary">ce lien</Link>.
            </p>
            <p>
                En utilisant Tossée, vous acceptez la collecte et l'utilisation de vos informations conformément à ce règlement. Si vous n'êtes pas d'accord avec les
                termes de ce règlement, veuillez ne pas utiliser notre application.
            </p>

            <ol className="p-4 flex flex-col gap-4">
                <li>
                    <h2 className="text-xl font-medium">
                        1. Informations que nous collectons
                    </h2>
                    <p>
                        Nous collectons les types d'informations suivants auprès de nos utilisateurs :
                    </p>
                    <ul className="p-4 flex flex-col gap-3 list-disc list-inside ">
                        <li>
                            <strong>Localisation :</strong> Nous collectons des informations de localisation, telles que la région, l'adresse IP, les coordonnées GPS ou des
                            informations sur les points d'intérêt à proximité de votre appareil. Cette collecte nous permet d'offrir des services personnalisés et d'améliorer
                            votre expérience utilisateur.
                        </li>
                        <li>
                            <strong>Activité de l'utilisateur :</strong> Nous surveillons l'activité de réseau, les clics, la position de la souris, l'enregistrement des mouvements
                            de défilement et les frappes du clavier pour comprendre comment nos utilisateurs interagissent avec Tossée. Ces informations nous aident à améliorer la
                            fonctionnalité et la performance de notre application.
                        </li>
                        <li>
                            <strong>Contenu du site web :</strong> Nous collectons des informations sur le contenu que vous visualisez ou interagissez lors de l'utilisation de notre
                            application, y compris le texte, les images, les sons, les vidéos et les liens hypertexte. Cette collecte nous permet d'analyser les tendances et
                            d'améliorer nos services.
                        </li>
                    </ul>
                </li>

                <li>
                    <h2 className="text-xl font-medium">
                        2. Utilisation des informations
                    </h2>
                    <p>
                        Nous utilisons les informations que nous collectons pour :
                    </p>
                    <ul className="p-4 flex flex-col gap-3 list-disc list-inside ">
                        <li>
                            Fournir, exploiter, et maintenir notre application.
                        </li>
                        <li>
                            Améliorer, personnaliser et étendre notre application.
                        </li>
                        <li>
                            Comprendre et analyser comment vous utilisez notre application.
                        </li>
                        <li>
                            Développer de nouveaux produits, services, fonctionnalités et fonctionnalités.
                        </li>
                        <li>
                            Communiquer avec vous, directement ou par l'intermédiaire de l'un de nos partenaires, notamment pour le service
                            client, pour vous fournir des mises à jour et d'autres informations relatives à l'application, et à des fins de
                            marketing et de promotion.
                        </li>
                        <li>
                            Vous envoyer des emails.
                        </li>
                    </ul>
                </li>

                <li>
                    <h2 className="text-xl font-medium">
                        3. Partage et divulgation des informations
                    </h2>
                    <p>
                        Nous ne partageons pas et ne divulguons vos informations personnelles à des tiers, sauf dans les cas suivants :
                    </p>
                    <ul className="p-4 flex flex-col gap-3 list-disc list-inside ">
                        <li>
                            Avec votre consentement.
                        </li>
                        <li>
                            Pour le respect des lois.
                        </li>
                        <li>
                            Pour fournir et protéger nos services.
                        </li>
                        <li>
                            Dans le cadre d'une fusion, acquisition ou vente de tous ou d'une partie de nos actifs.
                        </li>
                    </ul>
                </li>

                <li>
                    <h2 className="text-xl font-medium">
                        4. Sécurité des données
                    </h2>
                    <p>
                        Nous prenons des mesures pour protéger vos informations contre l'accès non autorisé, l'utilisation, la modification
                        et la divulgation. Cependant, aucun système de sécurité n'est impénétrable et nous ne pouvons garantir la sécurité de
                        vos informations à 100%.
                    </p>
                </li>

                <li>
                    <h2 className="text-xl font-medium">
                        5. Vos droits
                    </h2>
                    <p>
                        Vous avez le droit de consulter, modifier ou supprimer vos informations personnelles. Si vous souhaitez exercer ces droits,
                        veuillez nous contacter à <span className="underline text-secondary">contact@tossee.fr</span>.
                    </p>
                </li>

                <li>
                    <h2 className="text-xl font-medium">
                        6. Modifications de notre règlement de confidentialité
                    </h2>
                    <p>
                        Nous pouvons modifier ce règlement de confidentialité de temps à autre. Nous vous notifierons de toute modification en
                        publiant le nouveau règlement de confidentialité sur cette page. Nous vous encourageons à consulter régulièrement cette page
                        pour rester informé de nos pratiques en matière de confidentialité.
                    </p>
                </li>
            </ol>

            <h2 className="text-2xl font-medium">
                Contactez-nous
            </h2>
            <p>
                Si vous avez des questions sur ce règlement de confidentialité, veuillez nous contacter à <span className="underline text-secondary">contact@tossee.fr</span>.
            </p>
        </div>
    )
}